export const Infobox = {
  baseStyle: {
    messagebox: {
      color: "text.body",
    },
  },
  variants: {
    info: {
      messagebox: {
        backgroundColor: "background.action.infoInverse",
      },
    },
  },
}
